import { UserOutputDTO } from '@types';

export const UserMapper = {
  toDTO: (data: Partial<UserOutputDTO>): Partial<UserOutputDTO> => {
    return {
      ...data,
    };
  },

  toView: (data: UserOutputDTO): UserOutputDTO => {
    return data; // Return the same object for now, can be expanded if needed
  },
}; 